/* LUNA motion — G5 / D28.
   Two triggers, one class system:
     .luna-anim[data-luna-trigger="load"]   plays on the next paint (hero)
     .luna-anim[data-luna-trigger="scroll"] plays when it enters the viewport
   Plus the legacy .luna-rv reveal for sections that have no motion settings yet. */
(function(){
  if(window.__lunaMotion) return; window.__lunaMotion = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function play(el){ el.classList.add('is-ready'); }

  function initAnim(root){
    var nodes = (root||document).querySelectorAll('.luna-anim:not(.is-ready)');
    if(!nodes.length) return;
    Array.prototype.forEach.call(nodes, function(el){
      if(el.__luna) return; el.__luna = true;
      var stagger = el.getAttribute('data-luna-stagger');
      if(stagger) el.style.setProperty('--luna-stagger', stagger + 'ms');
      if(reduce){ play(el); return; }
      if(el.getAttribute('data-luna-trigger') === 'load'){
        // two frames: let the browser paint the pre-animation state before transitioning
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ play(el); }); });
        return;
      }
      if(!('IntersectionObserver' in window)){ play(el); return; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ play(e.target); io.unobserve(e.target); } });
      }, { threshold: .18, rootMargin: '0px 0px -8% 0px' });
      io.observe(el);
    });
  }

  function initReveal(root){
    var items = (root||document).querySelectorAll('.luna-rv:not(.is-in)');
    if(!items.length) return;
    if(reduce || !('IntersectionObserver' in window)){
      Array.prototype.forEach.call(items, function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        var el = e.target;
        var sibs = Array.prototype.filter.call(el.parentNode.children, function(n){
          return n.classList && n.classList.contains('luna-rv');
        });
        el.style.transitionDelay = (Math.min(sibs.indexOf(el), 4) * 90) + 'ms';
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { threshold: .15, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(items, function(el){ io.observe(el); });
  }

  function scan(root){ initAnim(root); initReveal(root); }
  document.addEventListener('DOMContentLoaded', function(){ scan(document); });
  if(document.readyState !== 'loading') scan(document);
  document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
  window.lunaReveal = scan;
})();